"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const crud_client_1 = require("./crud.client");
class MappingClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'mappings';
    }
    getUpdatePayloadModel(mapping, _) {
        return new MappingSaveRequestModel(mapping);
    }
    getAllWithPages(projectId, mappingFields, pageFields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/with-pages?` + this.getQueryString({ mappingFields, pageFields });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getWithSearch(projectId, searchRequestModel) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings?` + this.getQueryString(searchRequestModel);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    clone(projectId, mappingId, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            let body = {};
            let url = `/v1/projects/${projectId}/mappings/${mappingId}/clone`;
            if (overrides) {
                body = overrides;
            }
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    process(projectId, mappingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/process`;
            const response = yield this.httpPut(url);
            return response.payload;
        });
    }
    getPages(projectId, mappingId, fields, ids, includeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages?` + this.getQueryString({ fields, ids, includeDeleted });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getPageById(projectId, pageId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}?` + this.getQueryString({ fields });
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSuggestedPagesByUrl(projectId, requestUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/suggested-pages`;
            const response = yield this.httpPost(url, { url: requestUrl });
            return response.payload || [];
        });
    }
    getPagesByProject(projectId, fields, ids, includeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages?` + this.getQueryString({ fields, ids, includeDeleted });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getPagesWithSearch(projectId, searchRequestModel) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages?` + this.getQueryString(searchRequestModel);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getByPage(projectId, pageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}/mappings`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    createPage(projectId, mappingId, page) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}${mappingId ? `/mappings/${mappingId}` : ''}/pages/`;
            const response = yield this.httpPost(url, page);
            return response.payload;
        });
    }
    createPages(projectId, mappingId, pages) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/many`;
            const response = yield this.httpPost(url, pages);
            return response.payload || [];
        });
    }
    getPageCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/page-categories`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    deletePageRelation(projectId, mappingId, pageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    getExhaustiveness(projectId, mappingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/exhaustiveness`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getLinkedItems(projectId, mappingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/linkeditems`;
            const response = yield this.httpGet(url);
            return response.payload || {};
        });
    }
    deleteWithLinkedItems(projectId, mappingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/with-linkeditems`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    exportMapping(projectId, mappingId, destinationProjectId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/export/${destinationProjectId}`;
            const response = name ? yield this.httpPost(url, { name }) : yield this.httpPost(url);
            return response.payload || [];
        });
    }
    includeTargetFilters(projectId, mappingId, pageId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/include-target-filters`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    excludeTargetFilters(projectId, mappingId, pageId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/exclude-target-filters`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    deleteTargetFilters(projectId, mappingId, pageId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/delete-target-filters`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    moveTargetFilters(projectId, mappingId, pageId, pageDest, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/move-target-filters?${this.getQueryString(pageDest)}`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    getScreens(options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `/v1/projects/${options.projectId}/mappings/${options.mappingId}/screens?`;
            if (options.isSimplified) {
                url += `isSimplified=${options.isSimplified}`;
            }
            else {
                url += `isSimplified=false`;
            }
            if (options.filters) {
                url += `&filters=${encodeURIComponent(JSON.stringify(options.filters))}`;
            }
            if (options.sortOrder) {
                url += `&sortOrder=${options.sortOrder}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getTargetOnExclusion(projectId, mappingId, pageId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/get-target-on-exclusion`;
            const response = yield this.httpPost(url, filters);
            return response.payload;
        });
    }
    getUrls(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId, mappingId, filters } = request, queryParams = __rest(request, ["projectId", "mappingId", "filters"]);
            let url = `/v1/projects/${projectId}/mappings/${mappingId}/search-urls?${this.getQueryString(queryParams)}`;
            if (filters) {
                url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getUrlsV2(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId, mappingId, filters } = request, queryParams = __rest(request, ["projectId", "mappingId", "filters"]);
            let url = `/v2/projects/${projectId}/mappings/${mappingId}/search-urls?${this.getQueryString(queryParams)}`;
            let response;
            if (filters) {
                response = yield this.httpPost(url, { filters: JSON.stringify(filters) });
            }
            else {
                response = yield this.httpPost(url);
            }
            return response.payload || [];
        });
    }
    getViewsPerScreens(projectId, mappingId, aliasIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/views-per-screen?${this.getQueryString({
                aliasIds,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    updateColors(projectId, colors) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/colors`;
            const response = yield this.httpPut(url, colors);
            return response.payload;
        });
    }
    createPageThumbnail(projectId, mappingId, pageId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpPost(`/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/thumbnail`);
        });
    }
    getReferenceMappingForProject(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/reference-mapping`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getCategoriesForIndustry(industry) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/page-categories/industry/${industry}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getAllReferenceMappingTemplates() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = '/v1/mappings/templates';
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.MappingClient = MappingClient;
class MappingSaveRequestModel {
    constructor(mapping) {
        this.id = mapping.id;
        this.name = mapping.name;
        this.description = mapping.description;
        this.protected = mapping.protected;
        this.pages = mapping.pages;
        this.pageCount = mapping.pageCount;
        this.createdAt = mapping.createdAt;
        this.updatedAt = mapping.updatedAt;
        this.deletedAt = mapping.deletedAt;
        this.creatorId = mapping.creatorId;
        this.updaterId = mapping.updaterId;
        this.isFavorited = mapping.isFavorited;
        this.isReferenceMapping = mapping.isReferenceMapping;
        this.templateId = mapping.templateId;
        this.template = mapping.template;
    }
}
//# sourceMappingURL=mapping.client.js.map